import React from 'react';
import "./CardsPage.css";
import { Link } from 'react-router-dom';
import { BsJournals } from "react-icons/bs";
import { FaUserFriends } from "react-icons/fa";
import aboutimg from "../../Image/aboutimg.png"
import { saveUserActivity } from '../../commonServices/userTrackingService';

function CardsPage({ cards, heading, heading2 }) {

    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }


    return (
        <>
            {heading === 'CIVILS COURSES' && <div className='AllCardBackground'>
                <h1 className='fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger'>{heading}</h1>
                <div className='AllCard_Box'>
                    {cards.map((card, index) => (
                        <div className="card Allcard cursor-pointer" key={index}>
                            <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */
                                onClick={() => saveUserActivity("page_view", `visited ${card.CourseTitle}`, `/course ${card.TitleHeading}`)}
                            >
                                <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "250px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className='text-decoration-none text-black'>
                                    {card.CourseTitle ? <h6 className="fw-bold fs-4">{card.CourseTitle}</h6> : <h6 className="fw-bold fs-4">{card.Title}</h6>}
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item d-flex justify-content-between align-items-center w-40">
                                        <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount || 0} LESSONS`}</h6>
                                        {/* <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.SubscriberCount||0}</h6> */}
                                    </Link>
                                    <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className="btn-start list-group-item">START</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>}
            {heading === 'TEST SERIES' &&
                <div className='AllCardBackground'>
                    <h1 className='fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger'>{heading}</h1>
                    <div className='AllCard_Box'>
                        {cards.map((card, index) => (
                            <div className="card Allcard" key={index}>
                                <Link to={`/testseries/${card.TitleHeading}`} className='text-decoration-none text-black'
                                    onClick={() => saveUserActivity("page_view", `visited ${card.CourseTitle}`, `/testseries ${card.TitleHeading}`)}
                                >
                                    <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "250px" }} />
                                </Link>
                                <div className="card-body All-bg">
                                    <Link to={`/testseries/${card.TitleHeading}`} className='text-decoration-none text-black'>
                                        {card.CourseTitle ? <h6 className="fw-bold fs-5">{card.CourseTitle}</h6> : <h6 className="fw-bold fs-5">{card.Title}</h6>}
                                    </Link>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Link to="#" className="card-link list-group-item">
                                            {card.TopicCount ? <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount} LESSONS`}</h6> : <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuizCount || 0} Tests`}</h6>}
                                            {card.Subscriber && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.Subscriber} SUBSCRIBERS</h6>}
                                        </Link>
                                        <Link to={`/testseries/${card.TitleHeading}`} state={{ isEnrolled: card.isEnrolled }} className="btn-start list-group-item">START</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>}
            {heading === '' &&
                <div className='AllCardBackground p-0'>
                    {heading && <h1 className='fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger'>{heading}</h1>}
                    <div className='AllCard_Box'>
                        {cards.map((card, index) => (
                            <div className="card Allcard AllDashboard" key={index}>
                                <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className='text-decoration-none text-black'>
                                    <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "140px" }} />
                                </Link>
                                <div className="card-body All-bg">
                                    <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className='text-decoration-none text-black'>
                                        {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                    </Link>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Link to="#" className="card-link list-group-item">
                                            <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount || 0} LESSONS`}</h6>
                                            {card.Subscriber && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.Subscriber} SUBSCRIBERS</h6>}
                                        </Link>
                                        <Link to={`/course/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} key={index} */ className="btn-start list-group-item">START</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>}
            {heading2 === '' &&
                <div className='AllCardBackground p-0'>
                    {heading && <h1 className='fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger'>{heading}</h1>}
                    <div className='AllCard_Box'>
                        {cards.map((card, index) => (
                            <div className="card Allcard AllDashboard" key={index}>
                                <Link to={`/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                    <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ minHeight: "150px" }} />
                                </Link>
                                <div className="card-body All-bg">
                                    <Link to={`/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                        {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                    </Link>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Link to="#" className="card-link list-group-item">
                                            {card.TopicCount ? <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount} LESSONS`}</h6> : <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuizCount || 0} Tests`}</h6>}
                                            {card.SubscriberCount && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.SubscriberCount} SUBSCRIBERS</h6>}
                                        </Link>
                                        <Link to={`/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className="btn-start list-group-item">START</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>}
        </>
    )
}

export default CardsPage;